import React from 'react';

const AbacusInterfaceTitle: React.FC = () => <>Schnittstelle</>;
export default AbacusInterfaceTitle;
